export const LOAD_FAILED_MERCHANTS = 'LOAD_FAILED_MERCHANTS';
export const SET_FAILED_MERCHANTS = 'SET_FAILED_MERCHANTS';
export const EXPAND_ROW = 'EXPAND_ROW';
export const FAILED_LOAD = 'FAILED_LOAD';
export const DELETE_FAILED_MERCHANT = 'DELETE_FAILED_MERCHANT';
export const SET_FAILED_MERCHANT_DELETED = 'SET_FAILED_MERCHANT_DELETED';
export const CHANGE_FAILED_MERCHANTS_PAGE = 'CHANGE_FAILED_MERCHANTS_PAGE';
export const DELETE_ALL_FAILED_MERCHANTS = 'DELETE_ALL_FAILED_MERCHANTS';

export const loadFailedMerchants = () => ({
  type: LOAD_FAILED_MERCHANTS
});

export const setFailedMerchants = failedMerchants => ({
  type: SET_FAILED_MERCHANTS,
  failedMerchants
});

export const expandRow = id => ({
  type: EXPAND_ROW,
  id
});

export const failedLoad = () => ({
  type: FAILED_LOAD
});

export const deleteFailedMerchant = (failedMerchantId, showModal) => ({
  type: DELETE_FAILED_MERCHANT,
  failedMerchantId,
  showModal
});

export const setFailedMerchantDeleted = failedMerchantId => ({
  type: SET_FAILED_MERCHANT_DELETED,
  failedMerchantId
});

export const deleteAllFailedMerchants = () => ({
  type: DELETE_ALL_FAILED_MERCHANTS
});

export const changePage = page => ({
  type: CHANGE_FAILED_MERCHANTS_PAGE,
  page
});

const initialState = {
  loading: true,
  currentPage: 1,
  previouslyVisited: [1],
  failedMerchants: [],
  expandedRow: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_FAILED_MERCHANTS:
      return {
        ...state,
        loading: false,
        failedMerchants: action.failedMerchants
      };
    case EXPAND_ROW:
      return {
        ...state,
        expandedRowId: state.expandedRowId === action.id ? null : action.id
      };
    case FAILED_LOAD:
      return {
        ...state,
        failedLoad: true
      };
    case SET_FAILED_MERCHANT_DELETED:
      return {
        ...state,
        failedMerchants: state.failedMerchants.filter(
          merchant => merchant.id !== action.failedMerchantId
        )
      };
    case CHANGE_FAILED_MERCHANTS_PAGE:
      return {
        ...state,
        currentPage: action.page,
        previouslyVisited: state.previouslyVisited.includes(action.page)
          ? state.previouslyVisited
          : [...state.previouslyVisited, action.page]
      };
    default:
      return state;
  }
};
